import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let modifiedReq = request;
    const profileId = localStorage.getItem('profileId');
    const sessionToken = localStorage.getItem('sessionToken');

    if (profileId || sessionToken) {
      const headersConfig: any = {};
      if (profileId && !modifiedReq.headers.has('x-profile-id')) {
        headersConfig['x-profile-id'] = profileId;
      }
      if (sessionToken && !modifiedReq.headers.has('x-session-token')) {
        headersConfig['x-session-token'] = sessionToken;
      }
      if (Object.keys(headersConfig).length > 0) {
        modifiedReq = modifiedReq.clone({
          setHeaders: headersConfig
        });
      }
    }

    return next.handle(modifiedReq).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          if (body && (body.is_suspended === true || (body.status === 'error' && typeof body.data === 'string' && body.data.toLowerCase().includes('suspended')))) {
            const msg = typeof body.data === 'string' ? body.data : 'Your account has been suspended by the administrator. Please contact support.';
            this.handleSuspension(msg);
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          const isSuspended =
            error.error?.is_suspended === true ||
            (typeof error.error?.data === 'string' && error.error.data.toLowerCase().includes('suspended')) ||
            (typeof error.error?.message === 'string' && error.error.message.toLowerCase().includes('suspended')) ||
            (typeof error.message === 'string' && error.message.toLowerCase().includes('suspended'));

          if (isSuspended) {
            const msg = (typeof error.error?.data === 'string' && error.error.data) || error.error?.message || 'Your account has been suspended by the administrator. Please contact support.';
            this.handleSuspension(msg);
          }
        }
        return throwError(() => error);
      })
    );
  }

  private handleSuspension(message: string): void {
    if (localStorage.getItem('sessionToken') || localStorage.getItem('profileId')) {
      localStorage.clear();
      Swal.fire({
        title: 'Account Suspended',
        text: message,
        icon: 'error',
        confirmButtonColor: '#a73453',
        allowOutsideClick: false
      }).then(() => {
        this.router.navigate(['/login']);
      });
    }
  }
}
